export const MERCURE_CLIENT_EVENTS = {
  SUBSCRIPTION_CREATED: 'subscription:created',
  SUBSCRIPTION_CANCELLED: 'subscription:cancelled',
  DISCONNECTED: 'disconnected',
  CONNECTED: 'connected',
  UPDATE_RECEIVED: 'update:received',
  CONNECTION_STATE_CHANGED: 'connection:stateChanged',
  ERROR: 'error',
} as const;

export const CONNECTION_MANAGER_EVENTS = {
  STATE_CHANGE: 'stateChange',
  MESSAGE: 'message',
  ERROR: 'error',
} as const;

export const EVENT_SOURCE_EVENTS = {
  OPEN: 'open',
  MESSAGE: 'message',
  ERROR: 'error',
  CLOSE: 'close',
} as const;
